export const SupplierTypeIconMixin = {
  methods: {
    supplierTypeIcon(type) {
      let icon = "mdi-home";
      switch (type) {
        case "ACCOMMODATION":
          icon = "mdi-home";
          break;
        case "ACTIVITY":
          icon = "mdi-golf";
          break;
        case "TRAVEL":
          icon = "mdi-airplane";
          break;
        case "TRANSPORT":
          icon = "mdi-car";
          break;
        case "TRANSFER":
          icon = "mdi-car";
          break;
        case "PACKAGE":
          icon = "mdi-briefcase";
          break;
        case "OTHER":
          icon = "mdi-star";
          break;
        case "TEMPLATE":
          icon = "mdi-view-list";
          break;
        case "MANDATORY_CHARGES":
          icon = "mdi-currency-usd";
          break;
        case "REZGRAPH":
          icon = "mdi-extension";
          break;
      }
      return icon;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/SupplierTypeIconMixin.js